import { SubmitHandler, UseFormReturn } from "react-hook-form";

import { updatePaymentReminders } from "@api";

import { alertActions } from "@features/alert/alertSlice";

import { useAppDispatch } from "@hooks/reduxHooks";

import { PaymentRemindersForm } from "@SiteManagement/PaymentReminders/types/paymentreminders";

const useFormHandlers = ({
    methods,
}: {
    methods: UseFormReturn<PaymentRemindersForm>;
}) => {
    const dispatch = useAppDispatch();

    const onSubmit: SubmitHandler<
        Partial<PaymentRemindersForm>
    > = async data => {
        const { dirtyFields } = methods.formState;

        const filteredData: Partial<PaymentRemindersForm> = {};

        (Object.keys(dirtyFields) as Array<keyof PaymentRemindersForm>).forEach(
            field => {
                if (dirtyFields[field] && data[field] !== undefined) {
                    filteredData[field] = data[field];
                }
            },
        );

        // The API returns 204 for an empty body, so skip the request.
        if (Object.keys(filteredData).length === 0) {
            return;
        }

        try {
            await updatePaymentReminders(filteredData);
        } catch {
            dispatch(
                alertActions.error({
                    title: "The server encountered a problem updating the payment reminders.",
                    text: "If the problem continues, please reach out to an admin.",
                    dismissible: true,
                }),
            );
            return;
        }

        dispatch(
            alertActions.success({
                title: "Payment reminders updated successfully",
                dismissible: true,
            }),
        );

        methods.reset(data);
    };

    return { onSubmit };
};

export default useFormHandlers;
